export class ProviderInfo {
    public Name: string;
    public BannerPath: string;
    public InfoMessage:  InfoMessageFields;
    constructor(providerInfo: ProviderInfo) {
        const { Name, BannerPath, InfoMessage } = providerInfo;
        this.Name = Name;
        this.BannerPath = BannerPath;
        this.InfoMessage = InfoMessage ? new InfoMessageFields(JSON.parse(InfoMessage.toString())) : null;
    }
}


class InfoMessageFields {
    public TEXT: string;
    public URL: string;
    public URLText: string;
    constructor(infoMessageFields: InfoMessageFields) {
        const { TEXT, URL, URLText } = infoMessageFields;
        this.TEXT = TEXT;
        this.URL = URL;
        this.URLText = URLText;
    }

}